/** @format */

import {format} from 'date-fns';

import {PointName} from 'components/charts/multiline-chart/model/common';
import {generateGraphPointName} from 'helpers/miscHelpers';

import {DTO_DATE_FORMAT} from '../../constants/common';

interface ReturnZone {
  normalPoints: PointName[];
  forecastPoints: PointName[];
}

/**
 * Вычислит точки для обычной зоны и зоны прогноза.
 * @param rechartsDates
 */

const getForecastZonePoints = (rechartsDates: string[]): ReturnZone => {
  const today = format(new Date(), DTO_DATE_FORMAT);

  const pointsMap = rechartsDates.reduce<Record<string, PointName>>((acc, cur, index) => {
    acc[cur] = generateGraphPointName(index);
    return acc;
  }, {});

  const normalZone = rechartsDates.filter(date => date < today);
  const forecastZone = rechartsDates.filter(date => date >= today);

  return {
    normalPoints: normalZone.map(date => pointsMap[date]),
    forecastPoints: forecastZone.map(date => pointsMap[date]),
  };
};

export {getForecastZonePoints};
